<template>
	<div :contentPaddingTop="12" class="rule-manage" v-loading="loading">
		<platform-tab @change="handleClick" :showAll="false" :platformId="platformId" />
		<div class="rule-set" v-show="showPlatformContent">
			<!-- <el-button type="primary" :disabled="!!task_status" plain @click="goToRuleSetPage">规则设置</el-button> -->
			<div class="hint mt-12" v-if="task_status">部分数据正在订正中，暂不支持修改规则，请耐心等待…</div>
		</div>
		<div :class="[task_status ? 'mt-24' : '']" v-show="showPlatformContent">
			<div class="flex flex-just-start">
				<el-button :disabled="!!task_status" @click="goToRuleSetPage(1)" type="primary"
					>修改规则</el-button
				>
			</div>
			<ruleItem :flag="1" :showCustomRuleDialog="true" :showSwitch="false" @showCustomRuleDialog="showRuleExplainDialog">
				<template v-slot:title>
					<i class="i-coll-rule1"></i>
					<span class="font-h4-medium ml-6 mr-4">达人跟进规则</span>
				</template>
				<div class="rule-desc">
					{{ followRuleDesc }}
				</div>
				<template v-slot:ruleText>达人跟进规则</template>
			</ruleItem>

			<ruleItem :flag="2" :showSwitch="false" :showCustomRuleDialog="true" @showCustomRuleDialog="showRuleExplainDialog">
				<template v-slot:title>
					<i class="i-talent-flow"></i>
					<span class="font-h4-medium ml-6 mr-4">达人自动流转规则</span>
				</template>
				<div class="mr-24">
					<div class="rule-desc">
						{{ anchor_circulation_config ? '允许' : '不允许' }}
					</div>
					<el-table
						style="margin-left: -16px"
						v-if="anchor_circulation_config"
						:data="anchor_circulation_list"
						header-row-class-name="table-header-row"
						row-class-name="table-row"
					>
						<el-table-column label="适用达人" width="250">
							<template v-slot="{ row }">
								<span>{{ ruleData[row.key].name }}</span>
							</template>
						</el-table-column>
						<el-table-column label="规则内容">
							<template v-slot="{ row }">
								<div>
									{{ ruleData[row.key].first }}
									<span class="font-bold">{{ row.day }}</span>
									{{ ruleData[row.key].last }}
								</div>
							</template>
						</el-table-column>
						<el-table-column label="状态" min-width="250" align="right">
							<template v-slot>
								<div class="open">已开启</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</ruleItem>

			<ruleItem  :flag="3" :showCustomRuleDialog="true" :showSwitch="false" @showCustomRuleDialog="showRuleExplainDialog">
				<template v-slot:title>
					<i class="i-ruleList10"></i>
					<span class="font-h4-medium ml-6 mr-4">达人运营业绩归属</span>
				</template>
				<div class="rule-desc">
					{{ achievementsBelongDesc }}
					<div class="font-h4-regular mt-12" v-if="valid_type_map[valid_type]">
						{{ valid_type_map[valid_type] }}
					</div>
					<div v-if="valid_type == 1" class="font-h4-regular mt-12">
						<div v-if="valid_time.value == 1">本月</div>
						<div v-if="valid_time.value != 1">近{{ valid_time.value }}个月</div>
					</div>
				</div>
			</ruleItem>
		</div>
		<rule-explain-dialog ref="ruleExplainDialog" />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import ruleItem from '@/components/business/ruleItem';
import ruleExplainDialog from '../components/ruleExplainDialog';
import { getPartnerToAnchor } from '@/api/talentCRM';
import { ruleData } from '../js/data';
import { platformMixin } from '@rd/rd-ui';
import { PLATFORM_KS, drRoleType } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
export default {
	name: 'ruleManage',
	components: {
		ruleExplainDialog,
		ruleItem,
	},
	mixins: [platformMixin],
	data() {
		return {
			many_partner: '',
			task_status: '',
			anchor_circulation_config: '',
			anchor_circulation_list: [],
			ruleData,
			results_attribution: 1,
			platformId: '',
			valid_type: undefined,
			valid_time: undefined,
			loading: true,
			valid_type_map: Object.freeze({
				1: '从指定时间开始',
				2: '从合作进度创建开始',
				3: '从认领时间开始',
				4: '从寄样锁定开始',
			}),
		};
	},
	created() {
		this.platformId = +this.$route.query.platformId || +this.defaultPlatform;
		this.getPartnerToAnchor();
	},
	computed: {
		...mapState(['vuex_userInfo']),
		...mapGetters(['defaultPlatform']),
		achievementsBelongDesc() {
			return this.results_attribution == 0
				? '按参数链接判断归属'
				: this.results_attribution == 2
				? '按合作进度判断业绩归属'
				: this.isKsPlatform
				? '按达人跟进关系判断归属'
				: '优先按商务唯一认领关系判断归属';
		},
		isKsPlatform() {
			const { platformId } = this;
			return platformId == +PLATFORM_KS.value;
		},
		drName() {
			return drRoleType.name;
		},
		followRuleDesc() {
			return this.many_partner ? '多人跟进' : '单人跟进';
		},
	},
	methods: {
		async getPartnerToAnchor() {
			try {
				const { platformId } = this;
				const {
					code,
					data: {
						anchor_circulation_config,
						anchor_circulation_list = [],
						valid_type,
						valid_time,
						many_partner,
						task_status,
						results_attribution,
					} = {},
				} = await getPartnerToAnchor({ platform_id: platformId });
				if (code !== 0) return;
				this.many_partner = many_partner;
				this.results_attribution = results_attribution;
				this.valid_type = valid_type;
				this.valid_time = valid_time;
				this.task_status = task_status;
				this.anchor_circulation_config = anchor_circulation_config;
				this.anchor_circulation_list = anchor_circulation_list.filter(item => item.value == '1');
			} catch (error) {
				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		showRuleExplainDialog(flag) {
			const { platformId } = this;
			this.$refs.ruleExplainDialog.show(flag, platformId);
		},
		goToRuleSetPage(val) {
			const { platformId } = this;
			this.$router.push({
				path: '/settings/newRuleManage/drRuleSetting',
				query: {
					platformId,
					ruleType: val,
				},
			});
		},
		handleClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.getPartnerToAnchor();
		},
	},
};
</script>

<style lang="less" scoped>
.rule-desc {
	font-family: PingFang SC;
	font-size: 14px;
	font-weight: normal;
	line-height: 22px;
	letter-spacing: 0em;

	/* text/text-5-强调+正文标题 */
	color: #1d2129;
}
.rule-manage {
	.rule-set {
		display: flex;
		align-items: center;

		.hint {
			margin-left: 12px;
			font-size: 14px;
			color: #fa8f14;
		}
	}

	::v-deep .table-header-row th {
		background: #fff !important;
		border-bottom: 1px solid #e3e3e3 !important;
	}

	.open {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		&::before {
			content: '';
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background-color: #0fb820;
			margin-right: 4px;
		}
	}
}
</style>
